import React from "react";

const ShieldIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0003 17.5C10.0003 17.5 15.8337 15 15.8337 11.6667V9.16667M10.0003 17.5C10.0003 17.5 4.16699 15 4.16699 11.6667V9.16667M10.0003 17.5V9.16667M10.0003 2.5C11.667 4.16667 14.5837 4.30556 15.8337 4.16667V9.16667M10.0003 2.5C8.33366 4.16667 5.41699 4.30556 4.16699 4.16667V9.16667M10.0003 2.5V9.16667M10.0003 9.16667H15.8337M10.0003 9.16667H4.16699"
        stroke="#14141E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ShieldIcon;
